import { App } from "../Enums/App";
import { AppView } from "../Enums/AppView";
import {
    SetAppPastIntroAction,
    SetAppViewAction,
    SetCurrentAppAction,
    ShowHeaderNav,
    ResetAppPastIntroAction,
    SET_APP_VIEW,
    SET_CURRENT_APP,
    SET_APP_PAST_INTRO,
    SHOW_HEADER_NAV,
    RESET_APP_PAST_INTRO,
} from "../Types/AppActionTypes";

export const setCurrentApp = (app: App): SetCurrentAppAction => ({
    type: SET_CURRENT_APP,
    data: app,
});

export const setAppView = (view: AppView): SetAppViewAction => ({
    type: SET_APP_VIEW,
    data: view,
});

export const setAppPastIntro = (app: App): SetAppPastIntroAction => ({
    type: SET_APP_PAST_INTRO,
    data: app,
});

export const resetAppPastIntro = (app: App): ResetAppPastIntroAction => ({
    type: RESET_APP_PAST_INTRO,
    data: app,
});

export const showHeaderNav = (show: boolean): ShowHeaderNav => ({
    type: SHOW_HEADER_NAV,
    data: show,
});
